import { TestSuiteChooserPage } from '@live-webinar/broadcast';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/test-suite/'].update({
        staticData: { title: { page: 'TestSuite.PageHeading' } },
        component: authGuard(TestSuiteChooserPage)
    });
};
